import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import GetConfig from '../config'

export default function SimpleSnackbar(props) {
    const config = GetConfig();
    const [open, setOpen] = React.useState(false);

    const handleClose = (event, reason) => {
        props.handleOpen(false);
    };

    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <div>
            <Snackbar
                open={props.open}
                autoHideDuration={config.snackbar_span}
                onClose={() => props.handleOpen(false)}
                message={props.message}
                action={action}
            />
        </div>
    );
}